/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import pythonSVG from 'assets/resources/pages/software-services/logo/python2.svg';
import nodeSVG from 'assets/resources/pages/software-services/logo/node.svg';
import djangoSVG from 'assets/resources/pages/software-services/logo/django.svg';
import pyramidSVG from 'assets/resources/pages/software-services/logo/pyramid.svg';
import aiohttpSVG from 'assets/resources/pages/software-services/logo/aiohttp.svg';

export default [
  {
    src: pythonSVG,
    nameClass: 'img-fluid',
    alt: 'Python'
  },
  {
    src: nodeSVG,
    nameClass: 'img-fluid',
    alt: 'NodeJS'
  },
  {
    src: djangoSVG,
    nameClass: 'img-fluid',
    alt: 'Django'
  },
  {
    src: pyramidSVG,
    nameClass: 'img-fluid',
    alt: 'Pyramid'
  },
  {
    src: aiohttpSVG,
    nameClass: 'img-fluid',
    alt: 'AIOHTTP'
  },
]